<div fxLayout="column" fxLayoutGap="8px">
    <button mat-button mat-dialog-close="edit">Edit</button>
    <button mat-button mat-dialog-close="delete" color="warn">Delete</button>
</div>